import React from "react";
import ProfileBanner from "./profile_banner/ProfileBanner";
import WalletRank from "./wallet_rank/WalletRank";
import VarifyKyc from './verify_kyc_section/VerifyKyc';
import AccountManagement from './account_management/AccountManagement';

export default function Profile() {
  return (
    <div className="profile-section">
      <ProfileBanner />
      <WalletRank />
      <VarifyKyc/> 
      <AccountManagement/> 
    </div>
  );
}
